module.exports = __webpack_public_path__ + "static/media/login_image.3c83448d.jpg";